import { useState } from "react";
import { useAuth } from "../context/AuthContext";

const otherButtons = [
  {
    name: "approved",
    primaryColour: "#198754",
    secondaryColour: "#caf9ca",
  },
  {
    name: "pending",
    primaryColour: "#ffb020",
    secondaryColour: "#ffefc5",
  },
  {
    name: "rejected",
    primaryColour: "#f33838",
    secondaryColour: "#ffd5d5",
  },
];

const today = new Date().toLocaleDateString("en-GB", {
  weekday: "long",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

function Header({ title, date, buttons, status, colour = "#6f81f5", role }) {
  const { user } = useAuth();
  return (
    <header className="flex flex-row items-center w-full gap-[3rem] mb-[4rem] ">
      <div className="text-start">
        <h1
          className={`text-[${colour}] text-3xl/[1.5] font-semibold capitalize`}
        >
          {title}
        </h1>
        <span>{today || date}</span>
      </div>
      <div className="self-start">
        {buttons &&
          otherButtons
            .filter((x) => x.name !== status)
            .map((b, i) => (
              <a href={"/" + b.name} className="mx-1">
                <button
                  className={`rounded-lg cursor-pointer hover:scale-[105%] transition-all duration-300 text-[${b.primaryColour}] bg-[${b.secondaryColour}] py-2 px-3 font-semibold capitalize`}
                >
                  {b.name + " Forms"}
                </button>
              </a>
            ))}
      </div>
      <div className="flex gap-4 justify-end grow">
        <a className="flex gap-2 hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 6.50001C21 8.43001 19.43 10 17.5 10C15.57 10 14 8.43001 14 6.50001C14 4.57001 15.57 3.00001 17.5 3.00001C19.43 3.00001 21 4.57001 21 6.50001ZM19 11.79C18.5 11.92 18 12 17.5 12C16.0421 11.9974 14.6447 11.4171 13.6138 10.3862C12.583 9.3553 12.0026 7.95788 12 6.50001C12 5.03001 12.58 3.70001 13.5 2.71001C13.3185 2.48755 13.0897 2.30838 12.8302 2.18555C12.5707 2.06272 12.2871 1.99934 12 2.00001C10.9 2.00001 10 2.90001 10 4.00001V4.29001C7.03 5.17001 5 7.90001 5 11V17L3 19V20H21V19L19 17V11.79ZM12 23C13.11 23 14 22.11 14 21H10C10 21.5304 10.2107 22.0391 10.5858 22.4142C10.9609 22.7893 11.4696 23 12 23Z"
              fill="#6F81F5"
            />
          </svg>
          Updates
        </a>
        <a className="flex gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7C16 8.06087 15.5786 9.07828 14.8284 9.82843C14.0783 10.5786 13.0609 11 12 11C10.9391 11 9.92172 10.5786 9.17157 9.82843C8.42143 9.07828 8 8.06087 8 7ZM8 13C6.67392 13 5.40215 13.5268 4.46447 14.4645C3.52678 15.4021 3 16.6739 3 18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 16.6739 20.4732 15.4021 19.5355 14.4645C18.5979 13.5268 17.3261 13 16 13H8Z"
              fill="#6F81F5"
            />
          </svg>
          {`${role || user?.userRole?.value || "Validator"}`} Profile
        </a>
      </div>
    </header>
  );
}

export default Header;
